import Overlay from "../../../Componentes/Overlay";
import SidebarMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext";

const SidebarPedidos = () => {

    const { closeModal, openModal } = useModal();

    const handleOpenNovoPedidoCompra = () => {

        closeModal();
        openModal("modalNovoPedidoCompra");

    }

    const handleOpenEmailsBoletim = () => {

        closeModal();
        openModal("modalEmailsBoletim");

    }

    return (
        <>
            <Overlay state={ true } changeContent={ closeModal } >
                <SidebarMenu>
                    <SideMenuBtn
                        button="NOVO PEDIDO DE COMPRA"
                        clickFunc={ handleOpenNovoPedidoCompra }
                    />
                    <SideMenuBtn
                        button="E-MAILS BOLETIM"
                        clickFunc={ handleOpenEmailsBoletim }
                    />
                </SidebarMenu>
            </Overlay>
        </>
    )
}

export default SidebarPedidos;